<template>
    <div id="voice-agent-channels">
        <AppBreadCrumb :paths="[{ title: 'AI Ses Ajanı' }]" :select="true"></AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="ml-3 mt-3" style="flex: 0 0 100%">
                <div class="big-title">Ses Ajanı Kanalları</div>
                <div class="channels">
                    <div class="story channel-add" @click="$feature.beforeCreateVoiceAgentIntegration(createChannel)" :style="{ opacity: channelAddOpacity }">
                        <md-icon style="font-size: 30px; color: white">record_voice_over</md-icon>
                        <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">
                            Kanal Ekle
                        </span>
                    </div>
                    <div class="channel-item" v-for="(channel, index) in channels" :key="index" @click="goToDashboard(channel._id)">
                        <div class="icon-container">
                            <md-icon style="font-size: 40px; color: #673ab7">record_voice_over</md-icon>
                        </div>
                        <div class="name-container">
                            <span class="name">AI Ses Ajanı</span>
                        </div>

                        <div class="options">
                            <a-dropdown :trigger="['click']" placement="bottomRight">
                                <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                    <span class="material-icons">more_horiz</span>
                                </div>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item v-if="debugMode" @click="showChannelInfo(channel)" style="display:flex; gap: 5px">
                                            <i class="material-icons">info</i>
                                            <span>Kanal Bilgileri</span>
                                        </a-menu-item>
                                        <a-menu-item @click="copyChannelId(channel._id)" style="display:flex; gap: 5px">
                                            <i class="material-icons">content_copy</i>
                                            <span>Channel ID Kopyala</span>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <div class="icon-container" @click="showDeleteConfirmation(channel._id)">
                                                <md-icon style="margin-right: 10px">delete</md-icon>
                                                <span>Sil</span>
                                            </div>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a-modal
            :visible="deleteModal"
            icon="exclamation-circle"
            :title="'Ses Ajanı Entegrasyonu'"
            @cancel="deleteModal = false"
        >
            <p>Ses Ajanı kanalını silmek istediğinize emin misiniz?</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    Vazgeç
                </a-button>
                <a-button key="submit" type="danger" @click="deleteVoiceAgentChannel">
                    Sil
                </a-button>
            </template>
        </a-modal>

        <a-modal
            :visible="channelInfoModal"
            :title="'Kanal Bilgileri'"
            @cancel="channelInfoModal = false"
            width="600px"
        >
            <div v-if="selectedChannelPayload" class="channel-info-content">
                <pre class="json-payload">{{ JSON.stringify(selectedChannelPayload, null, 2) }}</pre>
            </div>
            <template #footer>
                <a-button key="submit" type="primary" @click="channelInfoModal = false">
                    Kapat
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";

export default {
    name: "VoiceAgentChannels",
    components: {
        AppBreadCrumb,
    },
    data() {
        return {
            deleteModal: false,
            deleteChannelId: null,
            channelInfoModal: false,
            selectedChannelPayload: null,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "retell"),
            debugMode: (state) => state.app.debugMode,
        }),
        channelAddOpacity() {
            return this.channels.length === 1 ? 0.5 : 1;
        },
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            createChannelAction: "channel/createChannel",
        }),
        copyChannelId(channelId) {
            navigator.clipboard.writeText(channelId).then(() => {
                this.$message.success("Channel ID kopyalandı");
            }).catch(() => {
                this.$message.error("Channel ID kopyalanamadı");
            });
        },
        showChannelInfo(channel) {
            this.selectedChannelPayload = channel.payload;
            this.channelInfoModal = true;
        },
        showDeleteConfirmation(id) {
            this.deleteModal = true;
            this.deleteChannelId = id;
        },
        goToDashboard(channelId) {
            this.$router.push(`/integrations/voice-agent/${channelId}/dashboard`);
        },
        createChannel() {
            if (this.channels.length === 1) {
                this.$message.error("Birden fazla Ses Ajanı kanalı oluşturamazsınız");
                return;
            }

            // Form göstermeden direk kanal oluşturma
            this.createChannelAction({
                type: "retell",
                name: "AI Voice Agent",
                payload: {},
            })
                .then(() => {
                    this.$message.success("Ses Ajanı kanalı başarıyla oluşturuldu");
                    this.listChannels();
                })
                .catch((err) => {
                    console.error("Kanal oluşturma hatası:", err);
                    this.$message.error("Ses Ajanı kanalı oluşturulurken bir hata oluştu");
                });
        },
        deleteVoiceAgentChannel() {
            this.deleteModal = false;
            this.deleteChannel(this.deleteChannelId).then(() => {
                this.$message.success("Ses Ajanı kanalı başarıyla silindi");
            });
        },
    },
    mounted() {
        this.listChannels();
    },
};
</script>

<style lang="scss" scoped>
#voice-agent-channels {
    width: 100%;
    min-height: calc(100vh - 50px);
    background: var(--color-bg-default);

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 170px;
                height: 70px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-top: 69px;
                overflow: hidden;
                position: relative;
                background: #fff;
                padding: 10px;
            }

            .name-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                font-size: 20px;
                font-weight: bold;
                margin-top: 10px !important;

                .phone {
                    font-size: 14px;
                    font-weight: normal;
                    color: #a4a4a4;
                }
            }

            span {
                margin: 1rem 0;
                margin-top: 10px !important;
                font-weight: bold;
                display: block;
                font-size: 20px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #673ab7;
            border-color: #673ab7;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }
}

.channel-info-content {
    .json-payload {
        background-color: #f5f5f5;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        padding: 16px;
        font-family: 'Courier New', Courier, monospace;
        font-size: 13px;
        line-height: 1.5;
        overflow-x: auto;
        max-height: 400px;
        overflow-y: auto;
        margin: 0;
    }
}
</style>
